export var intOnly = function intOnly(value) {
  return value.replace(/[^0-9]/g, '');
};